import { MarketCountryCode } from '@backmarket/http-api'

export const DISAMBIGUATED_MARKET_TIMEZONES: Partial<
  Record<MarketCountryCode, string>
> = {
  [MarketCountryCode.US]: 'America/Chicago',
  [MarketCountryCode.AU]: 'Australia/Sydney',
}
